import { render, staticRenderFns } from "./PricingPackages.vue?vue&type=template&id=63b52a3c"
import script from "./PricingPackages.vue?vue&type=script&lang=js"
export * from "./PricingPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports